import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { createTask } from "../api/todo.api";
import { CreateTaskResponse, TodoListType } from "../api/type";

type Ctx = { previous: TodoListType[]; clientId: string };

export function useCreateTask() {
  const queryClient = useQueryClient();

  return useMutation<CreateTaskResponse, unknown, string, Ctx>({
    mutationFn: (testo: string) => createTask({ testo }),

    onMutate: async (testo: string) => {
      await queryClient.cancelQueries({ queryKey: ["task-list"] });

      const previous = queryClient.getQueryData<TodoListType[]>(["task-list"]) ?? [];
      const clientId = `temp-${Date.now()}`;

      const optimistic: TodoListType = {
        id: 0, 
        clientId,
        userID: 0, 
        testo,
        cancellato: 0,
        completato: 0,
        data: new Date().toISOString(),
        data_comp: null,
        data_canc: null,
      };

      queryClient.setQueryData<TodoListType[]>(["task-list"], [optimistic, ...previous]);

      return { previous, clientId };
    },

    onError: (_err, _testo, ctx) => {
      if (!ctx) return;
      queryClient.setQueryData(["task-list"], ctx.previous);
      toast.error("Errore nella creazione della task.");
    },

    onSuccess: (res) => {
      if (res.status === "ok") toast.success(res.message ?? "Task creata.");
      else toast.error(res.message ?? "Errore nella creazione della task.");
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["task-list"] });
    },
  });
}
